import React from 'react';

// Modal de configuracoes do painel /monitor/uso-sistemas. Tudo persiste em
// localStorage via useMonitorConfig - nada vai pro backend.

export default function ConfigMonitorUsoModal({ aberto, onClose, config, atualizar, resetar, PRESET }) {
  if (!aberto) return null;

  return (
    <div
      className="modal d-block"
      tabIndex="-1"
      role="dialog"
      style={{ background: 'rgba(0,0,0,0.7)' }}
      onClick={(e) => { if (e.target === e.currentTarget) onClose(); }}
    >
      <div className="modal-dialog modal-dialog-centered" role="document" style={{ maxWidth: 560 }}>
        <div className="modal-content" style={{ background: 'var(--portal-surface)', color: 'var(--portal-text)' }}>
          <div className="modal-header" style={{ borderColor: 'var(--portal-border)' }}>
            <h5 className="modal-title">
              <i className="bi bi-sliders me-2" />
              Configuracoes do painel
            </h5>
            <button className="btn-close btn-close-white" onClick={onClose} aria-label="Fechar" />
          </div>

          <div className="modal-body" style={{ maxHeight: '70vh', overflowY: 'auto' }}>
            <p className="config-monitor__lead">
              Configuracao unica do painel — salva no banco e aplica pra todo mundo.
              Mudancas propagam pras outras estacoes em ate {Math.max(config.pollingSeg, 5)}s.
              {config._updatedBy ? (
                <><br /><small>Ultima alteracao: {config._updatedBy}</small></>
              ) : null}
            </p>

            <div className="config-monitor__grupo">
              <label className="config-monitor__label">
                Janela de atividade
                <span className="config-monitor__hint">Mostra apenas quem interagiu nos ultimos…</span>
              </label>
              <select
                value={config.janelaAtivoMin}
                onChange={(e) => atualizar({ janelaAtivoMin: Number(e.target.value) })}
              >
                {PRESET.janelaAtivoOpcoes.map((o) => (
                  <option key={o.valor} value={o.valor}>{o.label}</option>
                ))}
              </select>
            </div>

            <div className="config-monitor__grupo config-monitor__grupo--inline">
              <div>
                <label className="config-monitor__label">
                  Limiar verde
                  <span className="config-monitor__hint">Ate quantos segundos a bolha fica verde</span>
                </label>
                <input
                  type="number"
                  min="5"
                  max="600"
                  step="5"
                  value={config.verdeAteSeg}
                  onChange={(e) => atualizar({ verdeAteSeg: Number(e.target.value) })}
                />
              </div>
              <div>
                <label className="config-monitor__label">
                  Limiar amarelo
                  <span className="config-monitor__hint">Depois disso, vira cinza</span>
                </label>
                <input
                  type="number"
                  min="30"
                  max="3600"
                  step="30"
                  value={config.amareloAteSeg}
                  onChange={(e) => atualizar({ amareloAteSeg: Number(e.target.value) })}
                />
              </div>
            </div>

            <div className="config-monitor__grupo">
              <label className="config-monitor__label">
                Atualizacao automatica
                <span className="config-monitor__hint">Frequencia de polling do painel</span>
              </label>
              <select
                value={config.pollingSeg}
                onChange={(e) => atualizar({ pollingSeg: Number(e.target.value) })}
              >
                {PRESET.pollingOpcoes.map((o) => (
                  <option key={o.valor} value={o.valor}>{o.label}</option>
                ))}
              </select>
            </div>

            <div className="config-monitor__grupo">
              <label className="config-monitor__toggle">
                <input
                  type="checkbox"
                  checked={config.modoCompacto}
                  onChange={(e) => atualizar({ modoCompacto: e.target.checked })}
                />
                <span>Modo compacto (tabela densa)</span>
              </label>

              <label className="config-monitor__toggle">
                <input
                  type="checkbox"
                  checked={config.mostrarResumo}
                  onChange={(e) => atualizar({ mostrarResumo: e.target.checked })}
                />
                <span>Mostrar cards de resumo no topo</span>
              </label>

              <label className="config-monitor__toggle">
                <input
                  type="checkbox"
                  checked={config.esconderCinzas}
                  onChange={(e) => atualizar({ esconderCinzas: e.target.checked })}
                />
                <span>Esconder linhas cinzas (so quem ta ativo de fato)</span>
              </label>
            </div>
          </div>

          <div className="modal-footer" style={{ borderColor: 'var(--portal-border)' }}>
            <button className="btn btn-outline-secondary me-auto" onClick={resetar}>
              <i className="bi bi-arrow-counterclockwise me-1" /> Restaurar padrao
            </button>
            <button className="btn btn-primary" onClick={onClose}>Fechar</button>
          </div>
        </div>
      </div>
    </div>
  );
}
